/*
 * Copyright (C) 2018 Bruno López Trigo
 * 
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.

 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.

 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */

import React, {Fragment} from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import {Card, CardActionArea, Grid} from "@material-ui/core";
import CardMedia from "@material-ui/core/CardMedia";
import CardActions from "@material-ui/core/CardActions";
import StudentSmall from "../images/student_small.jpg"
import TeacherSmall from "../images/teacher_small.jpg"
const styles = theme => ({
  letters: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    marginTop: "30%",
    display: "flex",
    flexDirection: "column"
  },
  root: {
    marginTop: "80px",
    justifyContent: "center",
    justifyItems: "center",
    display: "block",
    flex: "1 1 auto",
    textAlign:"center"
  },
  rootWithoutMargin:{
    justifyContent: "center",
    justifyItems: "center",
    display: "flex",
  },
  title: {
    display: "inline-flex",
    textAlign:"center",
  },
  green: {
    color: "#4caf50"
  },
  orange: {
    color: "#f44336"
  },
  body: {
    marginTop: "30px"
  },
  button: {
    marginTop: "30px",
    backgroundColor: "#4caf50",
    fontSize: "20px",
    color: "white",
    "&:hover": {
      backgroundColor: "#357a38"
    }
  },
  card: {
    textAlign:"center",
    marginTop:"3%",
    margin:"3%",
    width:"100%",
    height:360,
  },
  media: {
    width:300,
    height:300,
  },
  actionArea:{
    display:"flex"
  }
});

function DoubleHomeCard(props) {
  const { classes } = props;
  return (
      <Fragment>
        <Grid  container justify="center">
          <Grid item xs={12} md={12} lg={12} className={classes.root}>
            <Fragment>
              <div style={{display:"inline-flex"}}>
                <Typography
                    variant="h2"
                    component="h2"
                    align="center"
                    className={classes.green}
                >
                  Expli
                </Typography>
                <Typography
                    variant="h2"
                    component="h2"
                    align="center"
                    className={classes.orange}
                >
                  Clas
                </Typography>
              </div>
              <div>
              <Typography
                  variant="h5"
                  component="h5"
                  align="center"
                  className={classes.body}
              >
                {props.language.labels[props.language.id].home}
              </Typography>
              </div>
            </Fragment>
          </Grid>
          <Grid item xs={12} md={12} lg={12} container  className={classes.rootWithoutMargin}>
            <Grid item xs={0} sm={0} md={2} lg={3} className={classes.rootWithoutMargin}>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} className={classes.rootWithoutMargin}>
            <Card className={classes.card}>
                   <div className={classes.title}>
                     <Typography
                         variant="h2"
                         component="h2"
                         align="center"
                         className={classes.green}
                     >
                       {props.language.labels[props.language.id].begi}
                     </Typography>
                     <Typography
                         variant="h2"
                         component="h2"
                         align="center"
                         className={classes.orange}
                     >
                       {props.language.labels[props.language.id].ner}
                     </Typography>
                   </div>

                   <CardActions>
                     <CardActionArea
                         className={classes.actionArea}
                         onClick={props.startSessionBeginner}
                     >

                       <CardMedia className={classes.media}
                                  image = {StudentSmall}
                                  title={"Beginner"}
                       />

                     </CardActionArea>
                   </CardActions>
                 </Card>
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3} className={classes.rootWithoutMargin}>
              <Card className={classes.card}>
                <div className={classes.title}>
                  <Typography
                      variant="h2"
                      component="h2"
                      align="center"
                      className={classes.green}
                  >
                    {props.language.labels[props.language.id].exp}
                  </Typography>
                  <Typography
                      variant="h2"
                      component="h2"
                      align="center"
                      className={classes.orange}
                  >
                    {props.language.labels[props.language.id].ert}
                  </Typography>
                </div>
                <CardActionArea
                    className={classes.actionArea}
                    onClick={props.startSession}
                >

                  <CardMedia className={classes.media}
                             image = {TeacherSmall}
                             title={"Expert"}
                  />

                </CardActionArea>
                <CardActions>

                </CardActions>
              </Card>
            </Grid>
            <Grid item xs={0} sm={0} md={2} lg={3} className={classes.rootWithoutMargin}>
            </Grid>
          </Grid>
        </Grid>
    </Fragment>
  );
}

DoubleHomeCard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(DoubleHomeCard);
